import { PAGES } from "../constants";

export const ALL_USERS = `${PAGES} [AllUsers]`;
export const USER_FORM = `${PAGES} [UserForm]`;

export const START_ALL_USERS_SCREEN = `${ALL_USERS} START`;
export const START_NEW_USER_SCREEN = `${USER_FORM} START_NEW_USER_SCREEN`;
export const SAVE_USER = `${USER_FORM} SAVE_USER`;
export const USER_IMPORT = `${PAGES} [UserImport]`;
export const SOFT_DELETE_USER = `${PAGES} [SoftDeleteUser]`;

export const startAllUsersScreen = ({ organizationId, subOrganizationId } = {}) => ({
  type: START_ALL_USERS_SCREEN,
  payload: { organizationId, subOrganizationId },
});

export const startNewUserScreen = () => ({
  type: START_NEW_USER_SCREEN,
});

export const saveUser = (userData) => ({
  type: SAVE_USER,
  payload: userData,
});

export const userImport = (formData) => ({
  type: USER_IMPORT,
  payload: formData,
});

export const softDeleteUSer = (userId) => ({
  type: SOFT_DELETE_USER,
  payload: userId,
});
